import { TodayOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { memo } from "react";
import Baseline from "../../../../components/form/Baseline";
import Input from "../../../../components/inputs/DateInput";
import { formatDate } from "../../../../utils/more/date_functions";
import SelectorBox from "../SelectorBox";

function DateInput({
  size,
  variant = "filled",
  value,
  onChange = () => {},
  error,
  isEditable = true,
  readOnly,
  disabled,
  endAdornment,
  margin = "dense",
  placeholder = "Data",
}) {
  if (!isEditable) {
    return (
      <Baseline
        Icon={TodayOutlined}
        value={value ? formatDate(value) : ""}
        label={"Data"}
      />
    );
  } else {
    return (
      <SelectorBox Icon={TodayOutlined} active={Boolean(value)}>
        <Input
          readOnly={readOnly}
          margin={margin}
          disableHelperText
          value={value}
          disabled={disabled}
          onChange={onChange}
          size={size || "small"}
          disableOpenPicker={disabled || readOnly}
          variant={variant}
          placeholder={placeholder}
          maxDate={new Date()}
          label={""}
          hiddenLabel
        />
        {endAdornment && (
          <Box display={"flex"} alignItems={"center"} pl={1}>
            {endAdornment}
          </Box>
        )}
      </SelectorBox>
    );
  }
}

export default memo(DateInput);
